<template>
  <div>
    <roles-menu></roles-menu>
    <div class="mt-3 elevation-12 grey lighten-4">
      <v-card>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-data-table
              :headers="headers"
              :items="hasAuthItems"
              hide-default-footer
              :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
            >
              <template #item="props">
                <tr>
                  <td class="text-left">
                    {{ props.item.type == 2 ? $t("global.permission") : $t("global.role") }}
                  </td>
                  <td class="text-left">{{ props.item.translated_name }}</td>
                  <td class="text-left">{{ props.item.description }}</td>
                  <td class="text-left">
                    <v-tooltip bottom>
                      {{ $t("global.delete") }}
                      <template #activator="{on}">
                        <v-btn @click.native="removeAuthItem(props.item.name)" icon v-on="on">
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template #no-data>
                <v-alert color="error" icon="warning">
                  {{ $t("settings.role.newUserNoPermissions") }}
                </v-alert>
              </template>
            </v-data-table>

            <v-row class="mt-5 md-0" style="margin-bottom: 15px">
              <v-col
                ><h4>{{ $t("settings.role.addPermissions") }}</h4></v-col
              >
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
              </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="availableAuthItems" :search="search">
              <template #item="props">
                <tr>
                  <td class="text-left">
                    {{ props.item.type == 2 ? $t("global.permission") : $t("global.role") }}
                  </td>
                  <td class="text-left">{{ props.item.translated_name }}</td>
                  <td class="text-left">{{ props.item.description }}</td>
                  <td class="text-left">
                    <v-tooltip bottom>
                      {{ $t("global.add") }}
                      <template #activator="{on}">
                        <v-btn @click.native="addAuthItem(props.item.name)" icon v-on="on">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-form>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import roleMapping from "../../../models/settings/defaultRoleMapping";
import RolesMenu from "../../../components/Settings/RolesMenu.vue";

export default {
  name: "SettingsRoleDefaultView",
  components: { RolesMenu },
  data: () => ({
    defaultRole: new roleMapping(),
    allAuthItems: [],
    search: null,
    formValid: true
  }),
  created() {
    this.defaultRole.load();
    this.axios.get("settings/role-mapping/available-auth-items").then(resp => {
      this.allAuthItems = resp.data;
    });
  },
  computed: {
    headers() {
      return [
        { text: this.$t("global.type"), value: "type", width: "5%" },
        { text: this.$t("global.name"), value: "name", width: "10%" },
        {
          text: this.$t("global.description"),
          value: "description",
          width: "80%"
        },
        {
          text: this.$t("global.actions"),
          sortable: false,
          value: "actions",
          width: "5%"
        }
      ];
    },
    availableAuthItems() {
      const array = [];
      for (let authItem of this.allAuthItems.filter(this.filterAlreadyHaveItems)) {
        array.push(authItem);
      }
      return array;
    },

    hasAuthItems() {
      const array = [];
      for (let authItem of this.allAuthItems) {
        for (let externalAuthItem of this.defaultRole.auth_items) {
          if (externalAuthItem === authItem.name) {
            array.push(authItem);
          }
        }
      }
      return array;
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.defaultRole
          .save()
          .then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            this.$router.push({ path: "/settings/role/default" });
          })
          .catch(response => {
            this.$store.dispatch("alertDialog", {
              content: this.$t("global.error.generalError.content") + response,
              title: this.$t("global.error.generalError.title")
            });
          });
      }
    },
    addAuthItem(authItemName) {
      this.defaultRole.auth_items.push(authItemName);
    },
    removeAuthItem(authItemName) {
      this.defaultRole.auth_items.splice(this.defaultRole.auth_items.indexOf(authItemName), 1);
    },
    filterAlreadyHaveItems(item) {
      for (let userAuthItem of this.defaultRole.auth_items) {
        if (userAuthItem === item.name) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style scoped></style>
